import { Wrapper } from "components/Wrapper"
import { Button } from "components/Button"
import { Text } from "components/Text"
import { Flag } from "components/Icon"
import { ArrowLeft } from "components/Icon"
import { useTranslator } from "components/Translator"

export const FlotillaHeader = ({ title, children, className }) => {
  return (
    <Wrapper>
      <div>
        <div className={className}>
          <Wrapper>
            <FlotillaHeaderTitle>{title}</FlotillaHeaderTitle>
          </Wrapper>
        </div>
        <div>{children}</div>
      </div>
    </Wrapper>
  )
}

const FlotillaHeaderTitle = ({ children }) => {
  const translator = useTranslator()
  return (
    <div className="space-y-4">
      <Button
        href={{ route: "app_club_shop_product_index" }}
        variant="text"
        color="secondary"
        className="px-4"
        iconLeft={<ArrowLeft className="w-4" />}
      >
        {translator.trans("club.product.show.back", null, "pages")}
      </Button>
      <div>
        <div className="flex items-center space-x-2">
          <Flag className="text-secondary-default w-4" />
          <Text variant="headline3" className="text-secondary-dark">
            Club
          </Text>
        </div>
        <Text variant="headline1" tag="h1" className="text-dark">
          {children}
        </Text>
      </div>
    </div>
  )
}
